import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';
import { User } from '@/modules/user/models/User';

export class EstateSignUpToken extends BaseEntityModel {
  id?: number;
  type: string;
  token: string;
  userId?: number | null;
  user?: Relationship<User> | null;

  constructor(model: Partial<EstateSignUpToken> = {}) {
    super(model);

    this.id = model.id;
    this.type = model.type;
    this.token = model.token as string;
    this.userId = model.userId;
    this.user = User.mapModelOrNull(model.user);
  }
}
